module.exports = __webpack_public_path__ + "m.no1.2160c16f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/m.no1.jpg
// module id = R3xI
// module chunks = 0